<template>
  <div class="page-content original-dialog">
    <div class="custom-detail">
      <el-breadcrumb separator="/" class="egl-breadcrumb">
        <el-breadcrumb-item :to="{ path: '/mail-magazine' }">{{ $locale("mail.list.title") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $locale("cinemaWebsite.custom.dialog.title") }}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-form class="egl-elm egl-detail dialog-content" :model="form" :rules="formRules" ref="detailForm"
        label-position="top">
        <el-col :span="24">
          <div class="form-module-tit">{{ $locale("sideMenu.cinemaWebsite.news") + $locale("cinemaWebsite.custom.dialog.title") }}
          </div>
        </el-col>
        <el-row>
          <el-col :span="3">
            <el-form-item :label="$locale('cinemaWebsite.news.table.header.category')" prop="category">
              <el-select v-model="form.category">
                <el-option v-for="item in categoryList" :label="item.value" :key="item.key"
                  :index="item.key" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item :label="$locale('cinemaWebsite.news.table.header.title')" prop="title">
              <el-input :placeholder="$locale('cinemaWebsite.news.form.title.plsInput')" v-model="form.title" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item :label="$locale('cinemaWebsite.news.table.header.subTitle')" prop="subTitle">
              <el-input :placeholder="$locale('cinemaWebsite.news.form.subTitle.plsInput')" v-model="form.subTitle" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item :label="$locale('global.image')" prop="img">
              <UploadContainer :imageList="[form.img]"
                @onSuccess="({ response }) => uploadSuccess(response, 'img')" @onDelete="deletePhoto('img')">
              </UploadContainer>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$locale('cinemaWebsite.news.table.header.content')" prop="content">
              <editor v-model="form.content" :height="1200" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item :label="$locale('mail.list.publishLocation')">
              <el-checkbox-group v-model="form.publicTarget">
                <el-checkbox-button label="memberPage">会員ページ</el-checkbox-button>
                <el-checkbox-button label="email">メール</el-checkbox-button>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <el-form-item :label="$locale('mail.detail.publishTarget')">
              <el-select v-model="form.scope" multiple clearable @change="selectScope_fn">
                <el-option label="全員" value="none"></el-option>
                <el-option v-for="(item, idx) in scopeList" :label="item.name" :key="idx" :value="item.id" :disabled="form.scope.includes('none')"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <el-form-item :label="$locale('global.status')">
              <el-select v-model="form.publicType" @change="changePublicTime">
                <el-option v-for="item in publishList" :label="item.name" :key="item.key"
                  :index="item.key" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.publicType === 'schedule'">
          <el-col :span="5">
            <CommDatePicker
              v-if="form.publicType === 'schedule'"
              v-model="form.publicTime"
              :value.sync="form.publicTime"
              width="100%"
              type="datetime"
              :showWeekly="true"
              :format="`yyyy-MM-dd HH:mm`"
              :pickerOptions="pickerOptions"
              @change="handlePublicTimeChange"
            />
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item :label="$locale('mail.detail.createDate')">
              {{ $route.path.indexOf('create') > -1 ? '-' : $safeFormatDate(form.createTime, { format: 'YYYY-MM-DD HH:mm'}) }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="4">
            <el-form-item :label="$locale('mail.list.lastUpdate')">
              {{ $route.path.indexOf('create') > -1 ? '-' : $safeFormatDate(form.lastUpdateTime, { format: 'YYYY-MM-DD HH:mm'}) }}
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="actionType === 'edit'">
            <el-row :gutter="20" type="flex" justify="end">
              <el-col :span="12">
                <el-form-item prop="testEmail">
                  <el-input v-model="form.testEmail" placeholder="テスト送信先メールアドレス" />
                </el-form-item>
              </el-col>
              <el-col :span="6"><el-button class="egl-btn-yellow" @click="sendTestEmail_fn">テスト送信</el-button></el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-col :span="24" class="ta-r">
          <el-button style="width: 200px;" class="egl-btn-yellow" @click="save_fn">{{
            actionType === "create" ? $locale("cinemaWebsite.news.form.submit") :
            $locale("global.confirm2") }}</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import UploadContainer from "@/components/common/UploadContainer";
import Editor from "@/components/common/Tinymce/Rich";
import CommDatePicker from "@/components/common/CommDatePicker";

import { categoryMapping, weekLocaleArray } from "@/utils/common";
import { publishMapping } from './script/index';
import countDownAlert from "@/utils/countDownAlert";
import { emailValidator } from "@/utils/formFieldValidator";

import { getmailingOptionListService, createNewsService, getNewsDetailService, updateNewsService, sendTestEmailService } from '@/helpers/service/api/mailMagazine';

export default {
  data() {
    return {
      tempPublicTime: 0,
      categoryList: Object.entries(categoryMapping).map(([key, value]) => ({
        key,
        value
      })),
      publishList: Object.entries(publishMapping).map(([key, value]) => ({
        key,       // 原对象的键
        className: value.className, // 保留 className
        name: value.content, // 将 content 转化为 name
      })),
      scopeList: [],
      form: {
        category: "",
        title: "",
        subTitle: "",
        img: "",
        content: "",
        publicTarget: ["memberPage"],
        scope: ["none"],
        publicType: 'public',
        publicTime: this.$moment(new Date()).add(1, 'minute').valueOf(),
        testEmail: "",
      },
      formRules: {
        category: [
          {
            required: true,
            message: this.$locale("cinemaWebsite.news.form.category.required"),
            trigger: ["change"]
          }
        ],
        title: [
          {
            required: true,
            message: this.$locale("cinemaWebsite.news.form.title.required"),
            trigger: ["blur"]
          }
        ],
        subTitle: [
          {
            required: true,
            message: this.$locale("cinemaWebsite.news.form.subTitle.required"),
            trigger: ["blur"]
          }
        ],
        testEmail: [
          {
            validator: emailValidator,
            trigger: ["blur", "change"]
          }
        ],
      },
      actionType: this.$route.path.indexOf("create") > -1 ? "create" : "edit",
      weekLocaleArray
    }
  },
  computed: {
    pickerOptions() {
      const vm = this;
      return {
        disabledDate: this.disabledDate,
        // 禁用小时选择（根据传入的日期判断是否禁用）
        disabledHours: (time) => {
          if (!time) return [];
          
          // 检查传入的日期是否被禁用
          if (vm.disabledDate && vm.disabledDate(time)) {
            return Array.from({ length: 24 }, (v, k) => k);
          }
          
          // 检查日期（不考虑时间）是否小于当前日期
          const selectedDateOnly = vm.$moment(time).startOf("day").valueOf();
          const currentDateOnly = vm.$moment().startOf("day").valueOf();
          if (selectedDateOnly < currentDateOnly) {
            return Array.from({ length: 24 }, (v, k) => k);
          }
          
          // 如果是今天，禁用会导致时间小于当前时间+1分钟的小时
          if (selectedDateOnly === currentDateOnly) {
            const minTime = vm.$moment().add(1, "minute").valueOf();
            const disabledHours = [];
            for (let h = 0; h < 24; h++) {
              const testTime = vm.$moment(time).hour(h).minute(0).second(0).valueOf();
              if (testTime < minTime) {
                disabledHours.push(h);
              }
            }
            return disabledHours;
          }
          
          return [];
        },
        // 禁用分钟选择（除了 0 分钟，其余全部禁用）
        disabledMinutes: () => {
          const minutes = [];
          for (let i = 0; i < 60; i++) {
            if (i !== 0) {
              minutes.push(i);
            }
          }
          return minutes;
        },
        // 禁用所有秒的选择
        disabledSeconds: () => {
          return Array.from({ length: 60 }, (v, k) => k);
        }
      };
    }
  },
  created() {
    getmailingOptionListService({ brandId: window.localStorage.getItem("brandId") }).then((res) => {
      if (res.data && res.data.length > 0) {
        this.scopeList = res.data;
      }
    })
  },
  mounted() {
    const newsId = this.$route.params.id
    if (newsId) {
      getNewsDetailService({ id: newsId }).then((res) => {
        console.log(res.data);
        if (res.data) {
          this.form = res.data;
          this.tempPublicTime = res.data.publicTime;
          if (res.data.scope && res.data.scope.length === 0) {
            this.form.scope = ['none'];
          } 
        }
      })
    }
  },
  methods: {
    uploadSuccess(res, key) {
      if (res.success) {
        this.form[key] = res.data;
      }
    },
    deletePhoto(key) {
      this.form[key] = "";
    },
    selectScope_fn(val) {
      if (val.includes('none')) {
        this.form.scope = ['none'];
      }
    },
    sendTestEmail_fn() {
      // 只验证 testEmail 字段
      this.$refs.detailForm.validateField("testEmail", errorMessage => {
        if (!errorMessage) {
          // 验证通过，执行发送测试邮件逻辑
          // TODO: 调用发送测试邮件的 API
          sendTestEmailService({
            id: this.form.id,
            email: this.form.testEmail
          }).then(res => {
            if (res.success) {
              this.$message.success("テストメールを送信しました");
            } else {
              this.$message.error("テストメール送信失敗");
            }
          });
        } else {
          // 验证失败，显示错误信息
          this.$message.error("テスト送信先メールアドレス正しくありません。");
        }
      });
    },
    save_fn() {
      // 先清除 testEmail 的验证错误（如果有），因为保存时不需要验证 testEmail
      this.$refs.detailForm.clearValidate("testEmail");

      // 验证表单，但排除 testEmail 字段
      // 使用 validateField 逐个验证需要的字段
      const fieldsToValidate = ["category", "title", "subTitle"];
      const validationResults = {};
      let validationCount = 0;

      fieldsToValidate.forEach(field => {
        this.$refs.detailForm.validateField(field, errorMessage => {
          validationResults[field] = !errorMessage;
          validationCount++;

          // 所有字段验证完成后执行
          if (validationCount === fieldsToValidate.length) {
            const allValid = Object.values(validationResults).every(result => result === true);

            if (allValid) {
              // 验证通过，执行保存逻辑
              let obj = this.$_.cloneDeep(this.form);
              obj = {
                brandId: window.localStorage.getItem("brandId"),
                ...obj,
                ...obj.scope.includes("none") ? {
                  scope: []
                } : {
                  scope: obj.scope
                }
              };
              if (this.actionType === "create") {
                createNewsService(obj).then(res => {
                  if (res.success) {
                    countDownAlert({ content: this.$locale("global.createSuccessfully"), callback: () => {
                      this.$router.push("/mail-magazine");
                    }});
                  }
                });
              } else {
                updateNewsService(obj).then(res => {
                  if (res.success) {
                    countDownAlert({ content: this.$locale("global.updateSuccessfully"), callback: () => {
                      this.$router.push("/mail-magazine");
                    }});
                  }
                });
              }
            } else {
              // 验证失败，聚焦到第一个错误字段
              setTimeout(() => {
                const isError = document.getElementsByClassName("is-error");
                if (isError[0] && isError[0].querySelector("input")) {
                  isError[0].querySelector("input").focus();
                }
              }, 100);
            }
          }
        });
      });
    },
    disabledDate(time) {
      return time.getTime() < this.$moment().add(1, 'minute').valueOf();
    },
    handlePublicTimeChange(value) {
      // 验证时间是否小于当前时间+1分钟
      if (!value || this.form.publicType !== 'schedule') return;
      
      const minTime = this.$moment().add(1, 'minute').valueOf();
      if (value < minTime) {
        // 如果时间小于最小值，自动调整为当前时间+1分钟
        this.$nextTick(() => {
          this.form.publicTime = minTime;
        });
      }
    },
    changePublicTime(val) {
      if (this.actionType === "create") return;
      if (val === "schedule") {
        this.form.publicTime = this.$moment(this.form.publicTime).startOf("hour").valueOf();
      } else {
        this.form.publicTime = this.tempPublicTime;
      }
    }
  },
  components: {
    UploadContainer,
    Editor,
    CommDatePicker,
  }
}
</script>